{
  "endTime": "Lõpuaeg",
  "startTime": "Algusaeg",
  "time": "Aeg"
}
